import { i as l, x as a, s as b } from "../../../lit-element-6iugfgmM.js";
import { e as f } from "../../../custom-element-wk-AooBb.js";
import { n as c } from "../../../property-BWlAHqg_.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import { o as h } from "../../../unsafe-svg-By8nNw37.js";
import "../../../sp-action-button-BV19roxo.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-open-in.js";
import { getCCXOpenFontSpecimenHref as u } from "../../../lib/CCX.js";
import { c as y } from "../../../ccx-DJ4cbQpp.js";
import { Analytics as d } from "../../../lib/Analytics.js";
import { Localize as g } from "../../../lib/I18N.js";
const x = { "open-in-ccx-button.open-in-ccx": "Try in Adobe Express", "open-in-ccx-button.design-now": "Design now" }, v = l`:host{display:inline-flex}`;
var w = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, i = (m, n, r, o) => {
  for (var s, t = o > 1 ? void 0 : o ? $(n, r) : n, p = m.length - 1; p >= 0; p--) (s = m[p]) && (t = (o ? s(n, r, t) : s(t)) || t);
  return o && t && w(n, r, t), t;
};
let e = class extends d(g(b, x)) {
  constructor() {
    super(...arguments), this.enableLibraries = !1, this._handleClick = () => {
      this.sendAnalyticsEvent("ccx-edit-font", { psName: this.psName });
    };
  }
  static get styles() {
    return v;
  }
  render() {
    return a`<sp-action-button @click="${this._handleClick}" href="${u(this.psName, this.previewString)}" target="_blank">${this.enableLibraries ? a`<span slot="icon">${h(y)}</span> ${this.t("open-in-ccx-button.design-now")}` : a`<sp-icon-open-in slot="icon"></sp-icon-open-in>${this.t("open-in-ccx-button.open-in-ccx")}`}</sp-action-button>`;
  }
};
i([c({ type: String })], e.prototype, "psName", 2), i([c({ type: String })], e.prototype, "previewString", 2), i([c({ type: Boolean })], e.prototype, "enableLibraries", 2), e = i([f("af-open-in-ccx-button")], e);
const P = e;
export {
  P as default
};
//# sourceMappingURL=OpenInCCXButton.js.map
